import { Tooltip } from '@progress/kendo-react-tooltip'
import { AjaxWrapper, HttpMethod } from 'generic/ajaxWrapper'
import React from 'react'
import * as Flash from '../../../flash';
import * as Constants from '../../constants'
import { IntegrationConfigRenderBase } from './integrationConfigRenderBase'

declare const RASA_SELF_SERVICE_API: string

export class ImpexiumConfigRender extends IntegrationConfigRenderBase {
  protected supportsFilter: boolean = false
  protected showContactsCount = false
  private systemAppName: string = 'systemAppName'
  private systemAppKey: string = 'systemAppKey'
  private systemAppId: string = 'systemAppId'
  private systemAppPassword: string = 'systemAppPassword'
  private systemAppUserEmail: string = 'systemAppUserEmail'
  private systemAppUserPassword: string = 'systemAppUserPassword'
  private selectedFilterName: string = 'selectedFilterName'

  protected initializeCustomProps() {
    if (this.systemApiAttribute && this.systemApiAttribute.app_name) {
      this.props.propertiesChanged({
        [this.systemAppName]: this.systemApiAttribute.app_name,
      })
    }
    if (this.systemApiAttribute && this.systemApiAttribute.app_key) {
      this.props.propertiesChanged({
        [this.systemAppKey]: this.systemApiAttribute.app_key,
      })
    }
    if (this.systemApiAttribute && this.systemApiAttribute.app_id) {
      this.props.propertiesChanged({
        [this.systemAppId]: this.systemApiAttribute.app_id,
      })
    }
    if (this.systemApiAttribute && this.systemApiAttribute.app_password) {
      this.props.propertiesChanged({
        [this.systemAppPassword]: this.systemApiAttribute.app_password,
      })
    }
    if (this.systemApiAttribute && this.systemApiAttribute.app_user_email) {
      this.props.propertiesChanged({
        [this.systemAppUserEmail]: this.systemApiAttribute.app_user_email,
      })
    }
    if (this.systemApiAttribute && this.systemApiAttribute.app_user_password) {
      this.props.propertiesChanged({
        [this.systemAppUserPassword]: this.systemApiAttribute.app_user_password,
      })
    }
    if (this.systemApiAttribute && this.systemApiAttribute.filter_name) {
      this.props.propertiesChanged({
        [this.selectedFilterName]: this.systemApiAttribute.filter_name,
      })
    }
  }

  protected isAuthenticateButtonEnabled(): boolean {
    return !this.state.isConnecting && !!this.props.data.systemAppName && !!this.props.data.systemAppKey
      && !!this.props.data.systemAppId && !!this.props.data.systemAppPassword &&
      !!this.props.data.systemAppUserEmail && !!this.props.data.systemAppUserPassword
  }

  protected connect() {
    const url = this.buildPopUpUrl()
    this.setState({
      isConnecting: true,
    })
    AjaxWrapper.ajax(url, HttpMethod.GET, {})
    .then((result) => {
      if (!!result.success) {
        window.location.href = Constants.INTEGRATIONS_CONFIG_URL + '?id=' + result.payload.communitySystemId + '&operation=' + `${result.operation}${Constants.SUCCESS}`
      } else {
        this.setState({
          isConnecting: false,
        })
        const errMsg = result.payload ? result.payload.message : ''
        this.props.context.store.dispatch(Flash.showFlashError(errMsg))
      }
    }).catch((err) => {
      this.setState({
        isConnecting: false,
      })
      let message = ''
      try {
        message = err.response.message
      } catch (e) {
        message = err.message
      }
      this.props.context.store.dispatch(Flash.showFlashError(message))
    })
  }

  protected buildPopUpUrl(): string {
    return `${RASA_SELF_SERVICE_API}/integrations/${this.props.data.systemName.replace(' ', '').toLowerCase()}-api-callback?state=${this.encodedCommunityIdentifier}&app_name=${this.props.data.systemAppName}&app_key=${this.props.data.systemAppKey}&app_id=${this.props.data.systemAppId}&app_password=${this.props.data.systemAppPassword}&app_user_email=${this.props.data.systemAppUserEmail}&app_user_password=${this.props.data.systemAppUserPassword}&filter_name=${this.props.data.selectedFilterName}`
  }

  protected renderCustomBox() {
    return <div className="api-key-wrapper">
      <div>
        {this.createTextBox('App Key', this.systemAppKey)}
      </div>
      <div>
        {this.createTextBox('App Name', this.systemAppName)}
      </div>
      <div>
        {this.createTextBox('App Id', this.systemAppId)}
      </div>
      <div>
        {this.createTextBox('App Password', this.systemAppPassword)}
      </div>
      <div>
        {this.createTextBox('App User Email', this.systemAppUserEmail)}
      </div>
      <div>
        {this.createTextBox('App User Password', this.systemAppUserPassword)}
      </div>
      <div>
        {this.createTextBox('Custom Field (Required else will sync all contacts)', this.selectedFilterName, '', false)}
      </div>
    </div>
  }

  private createTextBox(displayName: string, fieldName: string, helpText: string = '', isRequired = true) {
    return <div>
      <Tooltip openDelay={100} position="top" anchorElement="pointer" className="rasa-grid-tooltip">
        <div className="field-label-credentials">
          <span title={helpText || `Input your ${displayName}`}>
            {displayName} {isRequired ? '(Required)' : ''} 
          </span>
        </div>
      </Tooltip>
      <div className="input-wrapper">
        {!this.props.data.is_active
        ? <input className={`field-textbox field-textbox-${fieldName} system-api-key`}
            value={(this.props.data[fieldName] || '')}
            onChange={(e) => this.props.propertiesChanged({[fieldName]: e.target.value})}
            placeholder={`Enter your ${displayName}`}
          />
        : <div className={`field-textbox field-textbox-${fieldName} system-api-key`}>
            {(this.props.data[fieldName] || '')}
          </div>
        }
      </div>
    </div>
  }
}
